import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useTitle } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'

import UnpublishDialog from './UnpublishDialog'

const UnpublishButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { title } = useTitle()

  return (
    <>
      <Button
        variant="primary"
        onClick={() => openDialog('unpublish_title')}
        className="text-md py-1.5 px-3 flex flex-row items-center justify-center">
        {t('action.unpublish')}
      </Button>
      <UnpublishDialog titleId={title.uuid} />
    </>
  )
}

export default UnpublishButton
